import React from 'react'
import { getFeConfig, visualizeLoad, visualizeEMDCobrandImage , visualizeEMDCobrandCSS, updateEMDCobrandImage, updateEMDCobrandCSS, insertNewRefTableData} from "../api/api";
import {PageHeader, Button, Space, notification, Upload, message, Modal} from 'antd'
import TableDataSource from "../utils/TableDataSource";
import {TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {Form} from "@q4us-sw/q4us-ui";
import {MapToFilter} from "../utils/mappings";
import {UploadOutlined, AppstoreAddOutlined} from '@ant-design/icons';

const ImageButtonComponent = (props) => {
    const {row, dataIndex, index} = props;
    return <Space direction={'horizontal'} key={index}>
        <Button disabled={!row[dataIndex]} onClick={async () => {
            try {
                await visualizeEMDCobrandImage(row.id, dataIndex);
            }
            catch (err) {
                notification.error({ message: "Image loading failed" });
            }
        }}>View</Button>
        <Upload name={'file'}
            onChange={(info) => {
                // console.log(info)
            }}
            customRequest={async ({ file, onSuccess }) => {
                let body = new FormData();
                body.append('id', row.id);
                body.append('image', dataIndex);
                body.append('data', file);
                console.log(body);
                const res = await updateEMDCobrandImage(body);
                if(res.status === 200){
                    notification.success({message: `File [${file.name}] uploaded`})
                    onSuccess(res.data, res.request)
                }else{
                    notification.error({message: `File [${file.name}] upload failed`})
                }
            }}
            maxCount={1}
            beforeUpload={(file) => {
                const isPNG = file.type === 'image/png';
                if (!isPNG) {
                    message.error(`${file.name} is not a png file`);
                }
                return isPNG || Upload.LIST_IGNORE;

            }}

        >
            <Button icon={<UploadOutlined />}>Replace</Button>
        </Upload>
    </Space>; 
}
 
export const EMDashboardCobrand = (props) => {

    const [source, setSource] = React.useState(new TableDataSource());
    const [open, setOpen] = React.useState(false);

    const fetchData = async (values, page = {})=>{
        const filters = MapToFilter(values)
        return await visualizeLoad({
            tableName: 'dashboard_cobrand',
            orderBy: ['identifier asc'],
            filter:[...filters],
            page: { size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
        }) || {}
    }


    return <React.Fragment>
        <PageHeader title={"EM Dashboard Cobrand Configs"}/>
        <Space direction={`vertical`} style={{width: '100%'}}>
            <div style={{textAlign: 'right', paddingRight: 7,width: '100%'}} >
                <Button style={{width: 160}} icon={<AppstoreAddOutlined/>} onClick={()=>setOpen(true)}>Add New</Button>
            </div>
         <TableV2
            fetchConfig={async () => {
                const {data= {}} = await getFeConfig('dashboard_cobrand')
                const { statusCode, rows = [], fields = [] } = data;

                const rows2 = rows.map( x=> {
                    if(x.name === 'logo_full'){
                         const dataIndex = x.name;
                         const formatter = (row, index, name, type, formatted, value) =>{
                             return ImageButtonComponent({row, index, dataIndex});
                        }
                        return {...x, formatter}
                    }
                    if(x.name === 'logo_min'){
                         const dataIndex = x.name;
                         const formatter = (row, index, name, type, formatted, value) =>{
                             return ImageButtonComponent({row, index, dataIndex}); 
                        }
                        return {...x, formatter}
                    }
                    if(x.name === 'touch_icon'){
                         const dataIndex = x.name;
                         const formatter = (row, index, name, type, formatted, value) =>{
                            return ImageButtonComponent({row, index, dataIndex}); 
                        }
                        return {...x, formatter}
                    }
                    if(x.name === 'css'){
                         const dataIndex = x.name;
                         const formatter = (row, index, name, type, formatted, value) =>{
                             return <Space key={index}>
                                 <Button disabled={!row[dataIndex]} onClick={async () => {
                                     try {
                                         await visualizeEMDCobrandCSS(row.id);
                                     }
                                     catch (err) {
                                         notification.error({ message: "CSS loading failed" });
                                     }
                                 }}>View</Button>
                                 <Upload name={'file'}
                                     onChange={(info) => {
                                         // console.log(info)
                                     }}
                                     customRequest={async ({ file, onSuccess }) => {
                                         let body = new FormData();
                                         body.append('id', row.id);
                                         body.append('data', file);
                                         console.log(body);
                                         const res = await updateEMDCobrandCSS(body);
                                         if (res.status === 200) {
                                             notification.success({ message: `File [${file.name}] uploaded` })
                                             onSuccess(res.data, res.request)
                                         } else {
                                             notification.error({ message: `File [${file.name}] upload failed`})
                }
                                     }}
                                     maxCount={1}
                                     beforeUpload={(file) => {
                                         const isCSS = file.type === 'text/css';
                                         if (!isCSS) {
                                             message.error(`${file.name} is not a css file`);
                                         }
                                         return isCSS || Upload.LIST_IGNORE;

                                     }}

                                 >
                                     <Button icon={<UploadOutlined />}>Replace</Button>
                                 </Upload>
                             </Space>;
                         }
                        return {...x, formatter}
                    }
                    return x
                })

                return { data: { statusCode, rows: rows2, fields } };
            }}

            scroll={{y: 'calc(90vh - 40px)', x: 'max-content' }}
            fetchData={async (request) => {
                return await fetchData(request.options.filter || {}, request.page)
            }}

            editable={false}

            source={source}
        />
        </Space>

        <Modal
            centered
            closable={true}
            onCancel={()=>setOpen(false)}
            footer={null}
            bodyStyle={{paddingBottom: 60}}
            title={`Add New`}
            visible={open}
        >
            <Form maxHeight={`60vh`} schema={'dashboard_cobrand_form'} config={async () => {
                const res = await getFeConfig('dashboard_cobrand_form') || {}
                const { data: { rows = [] } = {} } = res;
                return rows.filter(({ generated }) => !generated).sort(({ sequence_no: a }, { sequence_no: b }) => { return a - b });
            }}
                submit={async (values) => {
                const {data} = await insertNewRefTableData(values, 'dashboard_cobrand');
                if(data.statusCode === 200){
                    notification.success({message: `Successful!`, description: `Please upload the relevant photos and styling files.`})
                }
                return true;
            }}  />
        </Modal>

    </React.Fragment>
}